import { colors, TableCell } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableCellStyled = styled(TableCell)`
  padding: 1.6rem 0;
  font-size: 1.4rem;
  line-height: 2rem;

  &:first-child {
    padding-left: 2.4rem;
    padding-right: 1rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  &:last-child {
    padding-right: 2.4rem;
  }
`;

export const InboundTableCellStyled = styled(TableCellStyled)`
  position: relative;
  vertical-align: middle;

  &::after {
    position: absolute;
    content: '';
    display: block;
    width: 0.8rem;
    height: 100%;
    background-color: ${colors.green[400]};
    top: 0;
    left: 0;
    border-radius: 6px 0 0 6px;
  }
`;
